<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>水位计数据</h6>
			<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>
			<el-date-picker unlink-panels class="querypicker" v-model.trim="value1" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

			<addressTree @obj="objdata"></addressTree>
		</div>
		<!--<div class="trees">
			<el-tree :default-expand-all='true' :expand-on-click-node="false" ref="tree" class="treeClass" :filter-node-method="filterNode" :data="treedata" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
		</div>-->
		<div class="tabBody" id="lineid">


		</div>

	</div>
</template>

<script>
  import {
    swjData
  } from "@/api/api.js";
	import addressTree from '@/components/mangement/addressTree.vue'

	export default {
		data() {
			return {
				tableHeight: window.innerHeight - 190,

				value1:'',
				pickerOptions: {
					//时间插件设置
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
			}
		},
		components: {
			addressTree
		},
		mounted() {
      let params = {
        ydbCode: "SX_YL_SD_077",
        identity: 1
      };
      this.swjFun(params);
		},
		methods: {
			objdata(data){
				console.log(data)
        let params = {
          ydbCode: data.ydbCode,
          identity: 1
        };
        this.swjFun(params);
			},
      swjFun(params) {
        swjData(params).then((res) => {
          // console.log("水位计", res.data)
          let times = [];
          let ydbDqsw = [];
          for (let i = 0; i < res.data.length; i++) {
            times.push(res.data[i].ydbShiJian);
            ydbDqsw.push(res.data[i].ydbDqsw);
          }
          this.lineCharts(times, ydbDqsw);
        });
      },
			lineCharts(times, ydbDqsw) {
				let lineid = this.$echarts.init(document.getElementById('lineid'));
				let option = {
					backgroundColor: '#fff',
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							label: {
								show: true,
								backgroundColor: '#fff',
								color: '#556677',
								borderColor: 'rgba(0,0,0,0)',
								shadowColor: 'rgba(0,0,0,0)',
								shadowOffsetY: 0
							},
							lineStyle: {
								width: 0
							}
						},
						backgroundColor: '#fff',
						textStyle: {
							color: '#5c6c7c'
						},
						padding: [10, 10],
					},
          // legend: {
          //   show: true,
          //   align: "left",
          //   left: '5%',
          //   top: '2%',
          //   type: 'plain',
          //   // icon:'rect',
          //   // itemGap: 25,
          //   // itemWidth: 18,
          //   data: ['当前水位']
          // },
					grid: {
						top: '5%',
						left: '5%',
						right: '3%',
						bottom: '12%',
						// containLabel: true
					},
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '30',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 20, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }, ],
					xAxis: [{
						type: 'category',
						color: '#59588D',
						axisLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
							},
						},
						axisLabel: {
							color: '#282828'
						},
						splitLine: {
							// show: true
						},

						axisTick: {
							show: false
						},
						// boundaryGap: true,
						data: times,

					}],

					yAxis: [{
						type: 'value',
						min: 0,
						splitNumber: 4,

						axisTick: {
							show: false,
						},

						axistick: {
							show: true,
							lineStyle: {
								color: '#224364',
							},
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#ccc',
							},
						},
						axisLabel: {
							textStyle: {
								color: '#acb0b6',
							},
						},
						splitLine: {
							lineStyle: {
								// type: 'dashed',
								color: ['#fff'],
							},
						},

					}],
					series: [{
						name: '当前水位',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						symbol: 'circle',
						symbolSize: 6,
						lineStyle: {
							normal: {
								color: "#48B3FF"
							},
						},
						label: {
							show: false,
							position: 'top',
							textStyle: {
								color: '#48B3FF',
							}
						},

						itemStyle: {
							color: "#48B3FF",
							borderColor: "#48B3FF",
							borderWidth: 2,

						},
						tooltip: {
							show: true
						},
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: 'rgba(195,230,255,1)'
									},
									{
										offset: 1,
										color: 'rgba(195,230,255,0.1)'
									}
								], false),
								shadowColor: 'rgba(195,230,255,0.1)',
								shadowBlur: 20
							}
						},
						data: ydbDqsw,
					}]
				};;
				lineid.clear();
				lineid.setOption(option)

			}
		}

	}
</script>

<style scoped>
	@import url('../../../common/css/mangementall.css');
	.zblxtree {
		width: 230px;
		height: calc(100% - 80px);
		height: -webkit-calc(100% - 80px);
		height: -moz-calc(100% - 80px);
		background: #f7f7f7;
		border-radius: 6px;
		float: left;
		overflow: auto;
		padding: 15px;
	}

	.zblxtreeSty {
		background: #f7f7f7;
		border-radius: 6px;
	}

	.tablelist {
		width: 100%;
		height: calc(100% - 50px);
		height: -webkit-calc(100% - 50px);
		height: -moz-calc(100% - 50px);
		float: right;
		position: relative;
	}

	.tablelistbox {
		width: 100%;
		heigt: 100%;
	}

	.clsjTis {
		position: absolute;
		left: 0px;
		top: 0px;
		right: 0px;
		bottom: 0px;
		margin: auto;
		width: 335px;
		height: 210px;
		border: 1px solid #cccccc;
		background: #f7f7f7;
		border-radius: 6px;
		font-size: 16px;
	}

	.ycllxname {
		float: left;
		line-height: 30px;
		font-size: 14px;
		margin-left: 10px;
		margin-top: 10px;
	}

	.cllx-select {
		float: left;
		margin-top: 10px;
		width: 230px;
	}

	.btn {
		position: absolute;
		bottom: 10px;
		right: 10px;
	}

	.zzct {
		font-size: 20px;
		margin-right: 10px;
	}

	.import-s {
		float: right;
		position: relative;
		width: 100px;
		height: 28px;
		background: #409eff;
		margin-right: 10px;
		border-radius: 4px;
		margin-top: 11px;
		overflow: hidden;
	}

	.import-s p {
		position: absolute;
		width: 100%;
		line-height: 28px;
		text-align: center;
		font-size: 14px;
		color: #fff;
		cursor: pointer;
	}

	.import-s p span {
		margin-right: 5px;
	}

	.import-s input {
		width: 100%;
		height: 28px;
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}
</style>
